module.exports = __webpack_public_path__ + "static/media/Global Gaming Survey Report -6.1efdc4a5.PNG";